import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value", "placeholder"]

import { computed, ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormAutocomplete',
  props: {
    id: null,
    placeholder: null,
    modelValue: null,
    country: null,
    size: null,
    error: null
  },
  emits: ["update:model-value", "update:lat", "update:lng"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:model-value', val: string | null): void;
  (e: 'update:lat', val: number| null): void;
  (e: 'update:lng', val: number | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id: string;
  placeholder?: string;
  modelValue?: string;
  country?: string[];
  size?: "xs" | "sm" | "md" | "lg";
  error?: string | null;
};






const input = ref<HTMLInputElement>()

const createInput = () => {
  if (!input.value) {
    return;
  }

  const autocompelete = new google.maps.places.Autocomplete(input.value);
  let country = props.country || ["IE", "GB"];
  autocompelete.setComponentRestrictions({
    country,
  });

  autocompelete.addListener("place_changed", () => {
    const place = autocompelete.getPlace();
    if (!place.place_id || !place.geometry) {
      return;
    }

    const { location } = place.geometry;
    if (location) {
      emit('update:model-value', input.value?.value ?? null)
      emit('update:lat', location.lat())
      emit('update:lng', location.lng())
    }
  });
}


const onChange = (e: InputEvent) => {
  const input = e.target as HTMLInputElement
  if (!input.value) {
    emit('update:model-value', null)
    emit('update:lat', null)
    emit('update:lng', null)
  }
}

onMounted(createInput)

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      class: "form-control",
      value: __props.modelValue,
      placeholder: __props.placeholder,
      ref_key: "input",
      ref: input,
      onInput: onChange
    }, null, 40, _hoisted_2),
    _createVNode(_component_Error, { error: __props.error }, null, 8, ["error"])
  ]))
}
}

})